import NProgress from "nprogress";
import "nprogress/nprogress.css";
import store from "@/store";
import router from "@/router";
import { canAccessRoute } from "@/utils/permission";
import { refreshPageTitle } from "@/utils/app-title";

// NProgress配置
NProgress.configure({ showSpinner: false });

const portal = process.env.VUE_APP_PORTAL || "combined";
const isCustomerPortal = portal === "customer";

// 登录路由
const loginUri = "/account/login";
const customerLoginUri = isCustomerPortal ? "/login" : "/customer/login";

// 默认路由
const defaultUri = "/";
const customerDefaultUri = isCustomerPortal
  ? "/workbench"
  : "/customer/workbench";

// 登录白名单
const whiteList = ["/account/login"];
const customerWhiteList = [customerLoginUri];

function hasCustomerPagePermission(customerInfo, permissionKey) {
  if (!permissionKey) return true;
  const permissions = customerInfo?.page_permissions || [];
  return permissions.includes(permissionKey);
}

/** 路由前置守卫 */
router.beforeEach(async (to, from, next) => {
  NProgress.start();

  refreshPageTitle(to.meta?.title);

  if (isCustomerPortal && to.path.startsWith("/customer")) {
    next({
      path: to.path.replace(/^\/customer(?=\/|$)/, "") || "/",
      query: to.query,
      replace: true,
    });
    NProgress.done();
    return;
  }

  const isCustomerRoute = isCustomerPortal || to.path.startsWith("/customer");

  if (isCustomerRoute) {
    const customerToken = store.getters.customerToken;
    let customerInfo = store.getters.customerInfo;

    if (customerToken) {
      try {
        if (!customerInfo.id || !Array.isArray(customerInfo.page_permissions)) {
          customerInfo = await store.dispatch("getCustomerMy");
        }
        if (to.path === customerLoginUri) {
          next({ path: customerDefaultUri });
        } else if (
          !hasCustomerPagePermission(customerInfo, to.meta?.customerPermission)
        ) {
          next({ path: customerDefaultUri, replace: true });
        } else {
          next();
        }
      } catch (error) {
        await store.dispatch("customerLogout");
        next({ path: customerLoginUri, query: { redirect: to.fullPath } });
        NProgress.done();
      }
    } else if (customerWhiteList.includes(to.path.toLowerCase())) {
      next();
    } else {
      next({ path: customerLoginUri, query: { redirect: to.fullPath } });
    }
    return;
  }

  const token = store.getters.token;
  const permission = store.getters.permission;

  if (token) {
    if (!permission.auth) {
      try {
        await store.dispatch("getMy");
        await store.dispatch("getPermission");
        /** 令牌存在时，登录页直接跳转 */
        if (to.path === loginUri) {
          next({ path: defaultUri });
        } else if (!canAccessRoute(store.getters.permission, to)) {
          next({ path: "/403" });
        } else {
          next();
        }
      } catch (error) {
        await store.dispatch("logout");
        next({ path: loginUri, query: { redirect: to.fullPath } });
        NProgress.done();
      }
    } else {
      if (!canAccessRoute(permission, to)) {
        next({ path: "/403" });
      } else {
        next();
      }
    }
  } else if (whiteList.includes(to.path.toLowerCase())) {
    /** 放行白名单 */
    next();
  } else {
    /** 定向登录页 */
    next({ path: loginUri, query: { redirect: to.fullPath } });
  }
});

/** 路由后置守卫 */
router.afterEach(() => {
  NProgress.done();
});
